import { AppComponentProps } from "../../types/AppComponentProps";
import { AccountMenu } from "./components/AccountMenu";
import { SearchSection } from "./components/SearchSection";
import { useHomeAppStyles } from "./styles";

export type HomeAppProps = AppComponentProps;

export const HomeApp = () => {
  const styles = useHomeAppStyles();

  return (
    <div className={styles.container}>
      <SearchSection />
      <AccountMenu />
    </div>
  );
};
